<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      {{ titleHero }}
      <b-button slot="right" type="is-primary" @click="backBtnAction">
        <span>Back</span>
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <customers-add :is-action="action"></customers-add>
    </section>
  </div>
</template>

<script>
import CustomersAdd from "@/components/Customers/CustomersAdd";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import router from "../../router/index";
import { mapGetters } from "vuex";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";

export default {
  name: "CustomersAddView",
  mixins: [UserPermissionMixin],
  components: { HeroBar, TitleBar, CustomersAdd },
  data() {
    return {
      subTitle: null,
      isModalActive: false,
      id: this.$route.params.id,
      url: window.location.href
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "switchCustomerView"
    ]),
    action() {
      let action;
      if (this.id && this.url.includes("/customers/edit/")) {
        action = "Edit";
      } else if (this.id && this.url.includes("/customers/view/")) {
        action = "View";
      } else {
        action = "Add";
      }
      return action;
    },
    titleHero() {
      return this.action + " Customer";
    },
    titleStack() {
      if (!this.switchCustomerView && !this.userExternalCheck()) {
        return [
          { url: "/customers", name: "Customer Profile" },
          { url: "/dashboard/uploaded-data", name: this.action + " Customer" }
        ];
      } else {
        return [{ url: "#", name: "Customer Information" }];
      }
    }
  },
  methods: {
    backBtnAction() {
      const isView = this.url.search("view");
      if (isView == -1) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          type: "is-danger",
          message: "Do you really want to leave? All your changes will be lost",
          onConfirm: () => router.go(-1)
        });
      } else {
        router.go(-1);
      }
      return 1;
    }
  }
};
</script>
